// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1ydmb","col":"styles_col__1bJti","fulfillmentStatus":"styles_fulfillmentStatus__2dEnR","emailCol":"styles_emailCol__hPHN1"};